import { useEffect, useState } from "react";
import "../styles/viewPrescriptionHistory.scss";
// import "../styles/viewPrescriptionHistory2.scss";

import { useDispatch, useSelector } from "react-redux";
import PatientRecords from "../Components/PatientRecords";
import RecordCRUD from "../Components/RecordCRUD";
import {
  CRUDRecordPopup,
  menuPrescriptionTab
} from "../Redux/Slice/rootSlice";
import {
  getSpecificPrescriptionTemplate
} from "../Redux/Thunk/Actions";

function ViewPrescriptionHistory({ loaderchange }) {
  const sideActive = useSelector((state) => state.counter.sidebarnav);
  const activeTab = useSelector((state) => state.counter.menuPrescriptionTab);
  const [dataPatientRecord, setDataPatientRecord] = useState(false);
  console.log(activeTab, "test");
  const prescriptionId = useSelector((state) => state.counter.prescriptionId);
  let recordpopup = useSelector((state) => state.counter.recordpopup);
  const [response, setResponse] = useState();
  const [response1, setResponse1] = useState();
console.log(response1,"response1")
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [recordCRUDpopup, setRecordCRUDpopup] = useState(recordpopup);
  const [patientId, setPatientId] = useState();
  const dispatch = useDispatch();
  console.log(recordCRUDpopup, "recordCRUDpopup");
  useEffect(() => {
    const handleThunk = async (props) => {
      const payload = prescriptionId;
      const patentDetails = getSpecificPrescriptionTemplate(payload);
      const response = await dispatch(patentDetails);
      if (response?.payload?.status?.code === 200) {
        setPatientId(response.payload.data.patient_id.id);
        console.log(response.payload.data.patient_id.id, "data show");
        // setResponse(response.payload.data.first_report_template);
        setResponse(response.payload.data.prescription_template);
        if (response?.payload?.data?.second_prescription_template != null && response?.payload?.data?.second_prescription_template != "") {
          setResponse1(response.payload.data.second_prescription_template);

        }
        // Swal.fire({
        //   title: "Successful.",
        //   text: "Record added successful.",
        //   icon: "success",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
      } else {
        // Swal.fire({
        //   title: "Unsuccessful.",
        //   text: "Error",
        //   icon: "warning",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
      }
    };
    // console.log("innnnnnnnnnnnnnnn");
    handleThunk();
  }, []);

  // console.log(response, "eeeeda");
  //   window.history.back();
  const handleTabClick = (e) => {
    dispatch(menuPrescriptionTab(e.target.name));
  };

  const PrintDiv = () => {
    var new_str = document.getElementById("demo").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = new_str;
    window.print();
    document.body.innerHTML = originalContents;
    // document.body.innerHTML = old_str;
    return false;
  };

  var mediaQueryList = window.matchMedia("print");
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log("before print dialog open");
    } else {
      window.location.reload();
      console.log("after print dialog closed");
    }
  });
  const handleAddRecord = (e) => {
    dispatch(CRUDRecordPopup(true));
    setRecordCRUDpopup(true);
  };
  // console.log(value_ne,"test")
  return (
    <>
      <div className={sideActive ? "patient-view-sa" : "patient-view"}>
        {recordCRUDpopup && (
          <RecordCRUD
            setclosepopup={setRecordCRUDpopup}
            loaderchange={loaderchange}
            prescriptionid_share={prescriptionId}
            patientid_share={patientId}
            datareload={setDataPatientRecord}
            currentdatareload={dataPatientRecord}
          />
        )}
        <div className="pageWrapper">
          <div className="content container-fluid">
            {/* Page Header Start */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">History</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Dashboard
                      </a>
                    </li>
                    <li className="breadcrumb-item">
                      <a
                        href="/Patients"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Patient
                      </a>
                    </li>
                    <li className="breadcrumb-item">
                      <a
                        href="PatientView"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Patient View
                      </a>
                    </li>
                    <li className="breadcrumb-item active">History</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="buttonHeader">
                <button
                  className="addPatientRecordbtn"
                  //   onClick={handleAddPrescription}
                  style={{ marginRight: "20px" }}
                  onClick={(e) => {
                    PrintDiv();
                  }}
                >
                  Print
                </button>
                <button
                  className="addPatientRecordbtn"
                  onClick={(e) => {
                    handleAddRecord(e);
                  }}
                >
                  Add Record
                </button>
              </div>
            </div>
            <div className="profile-menu" >
              <ul className="nav nav-tabs" role="tablist">
                {" "}
                <button
                  className={`nav-link${activeTab === "prescription" ? " active" : ""
                    } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="prescription"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => handleTabClick(e)}
                  style={{ marginRight: "5px" }}
                >
                  Patient prescription
                </button>
                <button
                  className={`nav-link${activeTab === "p_records" ? " active" : ""
                    } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="p_records"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => handleTabClick(e)}
                  style={{ marginRight: "10px" }}
                >
                  Patient records
                </button>
              </ul>
              {activeTab == "prescription" && (
                <div id="demo">
                  <div
                    className="demo"
                    style={{ maxWidth: "1200px" }}
                    dangerouslySetInnerHTML={{
                      __html: response,
                    }}
                  ></div>
                  {response1!=undefined&&<div
                    className="demo2"
                    style={{ maxWidth: "1200px" }}
                    dangerouslySetInnerHTML={{
                      __html: response1,
                    }}
                  ></div>}

                </div>
              )}
              {activeTab == "p_records" && (
                <PatientRecords
                  loaderchange={loaderchange}
                  patientId={patientId}
                  prescriptionId={prescriptionId}
                  typeshow={"prescription_specific"}
                  table_reload_data={dataPatientRecord}
                // set_reload_data = {setDataPatientRecord}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewPrescriptionHistory;
